export default "__VITE_ASSET__DtVIGnZZ__"